import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const StatusQueIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
      strokeWidth={strokeWidth}
    >
      <path
        d="M15.84 13.35L12.75 11.57V5C12.75 4.59 12.41 4.25 12 4.25C11.59 4.25 11.25 4.59 11.25 5V12C11.27 12.27 11.4 12.5 11.63 12.65L15.09 14.65C15.44 14.86 15.91 14.74 16.11 14.38C16.32 14.02 16.19 13.56 15.84 13.36V13.35Z"
        fill={color}
      />
      <path
        d="M12 0.25C5.52 0.25 0.25 5.52 0.25 12C0.25 18.48 5.52 23.75 12 23.75C18.48 23.75 23.75 18.48 23.75 12C23.75 5.52 18.48 0.25 12 0.25ZM12 22.25C6.35 22.25 1.75 17.65 1.75 12C1.75 6.35 6.35 1.75 12 1.75C17.65 1.75 22.25 6.35 22.25 12C22.25 17.65 17.65 22.25 12 22.25Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

StatusQueIcon.displayName = 'StatusQueIcon';
